import React, { useRef } from 'react';
import css from './styles.module.scss';
import { Grid, TextField, Typography } from '@material-ui/core';


interface InputProps {
    name: string;
    label: string;
    value: string;
    isPadding: boolean;
    elementFocus: any;
    updateData: any;
    isDisabled: boolean;
}

export const ProfileInput: React.FC<InputProps> = ({ name, label, value, isPadding, elementFocus, updateData, isDisabled }) => {
    const inputRef = useRef(null);
    return (
        <>
            <Grid container spacing={0} alignItems="flex-end" className={isPadding ? css.dividerInput : ''} onClick={() => elementFocus(inputRef)}>
                <Grid item xs={12} className={css.grid2}>
                    <Typography className={css.textInput}>{label}</Typography>
                    <TextField
                        inputRef={inputRef}
                        onChange={e => updateData(name, e.target.value)}
                        value={value ? value : ''}
                        variant="outlined"
                        disabled={isDisabled}
                        required
                        fullWidth
                        className={css.textField}
                    />
                </Grid>
            </Grid>
        </>
    );
};
